<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-lines-recadvs-received',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },

  computed: {
    ...mapGetters([
      'isShowCodeLinesReceived',
      'isShowItemCodeSellerRecadvLinesReceived',
      'isShowItemCodeBuyerRecadvLinesReceived',
      'isShowDescriptionRecadvLinesReceived',
      'isShowOrderLinesReceived',
      'isShowDeliveryNoteNumberRecadvLinesReceived',
      'isShowDeliveryNoteLineRecadvLinesReceived',
      'isShowDespatchQuantityLinesReceived',
      'isShowReceivedQuantityLinesReceived',
      'isShowAcceptedQuantityLinesReceived',
      'isShowMeasureRecadvLinesReceived',
      'isShowPriceLinesReceived',
      'isShowCurrencyRecadvLinesReceived',
      'isShowStatusRecadvLinesReceived',
      'isShowSubtypeRecadvLinesReceived'
    ])
  },

  methods: {
    ...mapActions([
      'isShowCodeLinesReceivedAction',
      'isShowItemCodeSellerRecadvLinesReceivedAction',
      'isShowItemCodeBuyerRecadvLinesReceivedAction',
      'isShowDescriptionRecadvLinesReceivedAction',
      'isShowOrderLinesReceivedAction',
      'isShowDeliveryNoteNumberRecadvLinesReceivedAction',
      'isShowDeliveryNoteLineRecadvLinesReceivedAction',
      'isShowDespatchQuantityLinesReceivedAction',
      'isShowReceivedQuantityLinesReceivedAction',
      'isShowAcceptedQuantityLinesReceivedAction',
      'isShowMeasureRecadvLinesReceivedAction',
      'isShowPriceLinesReceivedAction',
      'isShowCurrencyRecadvLinesReceivedAction',
      'isShowStatusRecadvLinesReceivedAction',
      'isShowSubtypeRecadvLinesReceivedAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'code':
          isShow = !this.isShowCodeLinesReceived
          this.isShowCodeLinesReceivedAction(isShow)
          break
        case 'itemCodeSeller':
          isShow = !this.isShowItemCodeSellerRecadvLinesReceived
          this.isShowItemCodeSellerRecadvLinesReceivedAction(isShow)
          break
        case 'itemCodeBuyer':
          isShow = !this.isShowItemCodeBuyerRecadvLinesReceived
          this.isShowItemCodeBuyerRecadvLinesReceivedAction(isShow)
          break
        case 'description':
          isShow = !this.isShowDescriptionRecadvLinesReceived
          this.isShowDescriptionRecadvLinesReceivedAction(isShow)
          break
        case 'order':
          isShow = !this.isShowOrderLinesReceived
          this.isShowOrderLinesReceivedAction(isShow)
          break
        case 'deliveryNoteNumber':
          isShow = !this.isShowDeliveryNoteNumberRecadvLinesReceived
          this.isShowDeliveryNoteNumberRecadvLinesReceivedAction(isShow)
          break
        case 'deliveryNoteLine':
          isShow = !this.isShowDeliveryNoteLineRecadvLinesReceived
          this.isShowDeliveryNoteLineRecadvLinesReceivedAction(isShow)
          break
        case 'despatchQuantity':
          isShow = !this.isShowDespatchQuantityLinesReceived
          this.isShowDespatchQuantityLinesReceivedAction(isShow)
          break
        case 'receivedQuantity':
          isShow = !this.isShowReceivedQuantityLinesReceived
          this.isShowReceivedQuantityLinesReceivedAction(isShow)
          break
        case 'acceptedQuantity':
          isShow = !this.isShowAcceptedQuantityLinesReceived
          this.isShowAcceptedQuantityLinesReceivedAction(isShow)
          break
        case 'measure':
          isShow = !this.isShowMeasureRecadvLinesReceived
          this.isShowMeasureRecadvLinesReceivedAction(isShow)
          break
        case 'price':
          isShow = !this.isShowPriceLinesReceived
          this.isShowPriceLinesReceivedAction(isShow)
          break
        case 'currency':
          isShow = !this.isShowCurrencyRecadvLinesReceived
          this.isShowCurrencyRecadvLinesReceivedAction(isShow)
          break
        case 'status':
          isShow = !this.isShowStatusRecadvLinesReceived
          this.isShowStatusRecadvLinesReceivedAction(isShow)
          break
        case 'subtype':
          isShow = !this.isShowSubtypeRecadvLinesReceived
          this.isShowSubtypeRecadvLinesReceivedAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('recadv.recadv_entity_table_detail.code'), value: 'code', show: this.isShowCodeLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.itemCodeSeller'), value: 'itemCodeSeller', show: this.isShowItemCodeSellerRecadvLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.itemCodeBuyer'), value: 'itemCodeBuyer', show: this.isShowItemCodeBuyerRecadvLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.description'), value: 'description', show: this.isShowDescriptionRecadvLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.order'), value: 'order', show: this.isShowOrderLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.deliveryNoteNumber'), value: 'deliveryNoteNumber', show: this.isShowDeliveryNoteNumberRecadvLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.deliveryNoteLine'), value: 'deliveryNoteLine', show: this.isShowDeliveryNoteLineRecadvLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.despatch_quantity'), value: 'despatchQuantity', show: this.isShowDespatchQuantityLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.received_quantity'), value: 'receivedQuantity', show: this.isShowReceivedQuantityLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.accepted_quantity'), value: 'acceptedQuantity', show: this.isShowAcceptedQuantityLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.measure'), value: 'measure', show: this.isShowMeasureRecadvLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.price'), value: 'price', show: this.isShowPriceLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.currency'), value: 'currency', show: this.isShowCurrencyRecadvLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.status'), value: 'status', show: this.isShowStatusRecadvLinesReceived
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.subtype'), value: 'subtype', show: this.isShowSubtypeRecadvLinesReceived
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
